import React from 'react';
import { useNavigate } from 'react-router-dom';
import { Stack, IconButton, Avatar } from '@mui/material';
import AccountCircleOutlinedIcon from '@mui/icons-material/AccountCircleOutlined';
import MenuIcon from '@mui/icons-material/Menu';
import CloseIcon from '@mui/icons-material/Close';
import { userModelType } from '../../../features/auth/types';

interface AppHeaderProps {
  user: userModelType;
  onMenuClick?: () => void;
  isMenuOpen?: boolean;
}

export const AppHeaderMobile: React.FC<AppHeaderProps> = ({ user, onMenuClick, isMenuOpen }) => {
  const navigate = useNavigate();

  const handleUserPageOpen = () => {
    navigate('/prediction/client');
  };

  return (
    <Stack direction="row" spacing={1} sx={{ alignItems: 'center' }}>
      {/* ユーザアイコン */}
      <IconButton
        color="inherit"
        aria-label="user info"
        onClick={handleUserPageOpen}
        size="large"
      >
        <Avatar sx={{ width: 32, height: 32, bgcolor: 'transparent' }}>
          <AccountCircleOutlinedIcon color='success' />
        </Avatar>
      </IconButton>

      {/* ハンバーガーアイコン（モバイル用） */}
      <IconButton
        color="success"
        aria-label={isMenuOpen ? 'close sidebar' : 'open sidebar'}
        onClick={onMenuClick}
        sx={{ mr: 1 }}
      >
        {isMenuOpen ? <CloseIcon /> : <MenuIcon />}
      </IconButton>
    </Stack>
  );
};
